import { useInternalNotesVisibility } from "app/hooks/shared/useInternalNotesVisibility";
import { useCartContext } from "app/providers/CartProvider";
import React, { ChangeEvent } from "react";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

interface Props {
  className?: string;
}
const InternalNotes: React.FC<Props> = ({ className }) => {
  const cartContext = useCartContext();
  const cart = cartContext.getCart();

  const canSeeInternalNotes = useInternalNotesVisibility().data;

  const onTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (cart.internalNotes.length > 0) {
      cart.internalNotes[0] = e.target.value;
    } else {
      cart.internalNotes.push(e.target.value);
    }
    cartContext.updateCart(cart);
  };

  return (
    <>
      {canSeeInternalNotes && (
        <section className={className}>
          <Heading headingLevel="h2" className="gg-mb-2">
            Opmerkingen
          </Heading>
          <Text className="gg-mb-4">
            Wil je nog wat extra informatie voor ons achterlaten? Vul dit dan
            hier in.
          </Text>
          <textarea
            className="gg-w-full gg-border gg-border-grey-600 gg-px-5 gg-py-4"
            rows={4}
            placeholder="Laat je opmerking achter"
            onChange={onTextAreaChange}
          ></textarea>
        </section>
      )}
    </>
  );
};
export default InternalNotes;
